(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/views/tipsen/rounds.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/views/tipsen/rounds.js');

'use strict';

svs.game_results.views.Rounds = Marionette.View.extend({
  noRounds: true,
  template(data) {
    return svs.game_results.templates.rounds(data);
  },
  templateContext() {
    return {
      noRounds: !this.hasRounds
    };
  },
  className() {
    let className = 'game-results';
    className += this.model && this.model.get('product') ? " game-results-".concat(this.model.get('product')) : '';
    return className;
  },
  regions: {
    bigStatRegion: '#bigStatRegion',
    gameResultsLive: '#game-results-live'
  },
  modelEvents: {
    'change:rounds': 'render',
    change: 'setUpDimensions'
  },
  initialize() {
    this.hasRounds = this.model.get('rounds') && this.model.get('rounds').length > 0;
  },
  onRender() {
    const self = this;
    if (!svs.core.detect.formfactor.mobile()) {
      this.setUpDimensions();
      svs.core.detect.orientation.on('change', () => {
        self.setUpDimensions();
      });
      $('body').addClass('game-result-wrap');
    }
    const rounds = this.model.get('rounds');
    this.hasRounds = rounds && rounds.length > 0;
    if (this.hasRounds) {
      this.roundList = new svs.game_results.collections.RoundList(rounds);
      this.showChildView('gameResultsLive', new svs.game_results.views.RoundList({
        collection: this.roundList
      }));
    }
    $('.game-results-calendar').css('width', $('#gameResult').width());
  },
  setUpDimensions() {
    if (!svs.core.detect.formfactor.mobile()) {
      const $bigStatRegion = $('#bigStatRegion');
      $bigStatRegion.css('height', window.innerHeight - $('#top-content').height());
      $bigStatRegion.addClass("".concat(this.model.get('product'), "-background animate animate-show"));
      $('#coupon').css({
        height: "".concat(window.innerHeight - $('.js-top-content').height() - 12, "px"),
        'overflow-y': 'auto',
        '-webkit-overflow-scrolling': 'touch'
      });
    }
  }
});

 })(window);